<template>
  <div>
    <el-tag
      v-for="(tag, idx) in value"
      :key="idx"
      type="primary"
      :closable="!_readonly"
      :close-transition="false"
      @close="handleClose(idx)">
      {{tag}}
    </el-tag>

    <el-input v-if="!_readonly" type="text" class="input-new-tag"
              style="display: inline-block"
              v-model="inputValue"
              :placeholder="spec.placeholder"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"></el-input>
  </div>
</template>

<script>
  import mixin from './mixin'
  import {Tag, Input} from 'element-ui';

  export default {
    name: 'f-tags',
    mixins: [mixin],
    components: {
      [Tag.name]: Tag,
      [Input.name]: Input,
    },
    data() {
      return {
        inputValue: '',
      }
    },
    methods: {
      handleClose(idx) {
        this.value.splice(idx, 1)
      },

      handleInputConfirm() {
        let inputValue = this.inputValue
        if (inputValue) {
          if (!(this.spec.unique && this.value != null && this.value.indexOf(inputValue) >= 0)) {
            if (this.value == null) {
              this.value = [inputValue];
            } else {
              this.value.push(inputValue)
            }
          }
        }
        this.inputValue = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// f-tags.vue?65db8095